import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RefreshGridService {
  public refreshRequestGrid = new Subject<boolean>();
  private engagementAddedSource = new Subject<void>();
  private clientAddedSource = new Subject<void>(); // Add for client added

  engagementAdded$ = this.engagementAddedSource.asObservable();
  clientAdded$ = this.clientAddedSource.asObservable(); // Observable for client added

  private refreshNotificationBellSource = new Subject<void>();
  refreshNotificationBell$ = this.refreshNotificationBellSource.asObservable();

  constructor(private readonly httpClient: HttpClient) {}

  emitEngagementAdded() {
    this.engagementAddedSource.next();
  }

  emitClientAdded() { // Emit client added event
    this.clientAddedSource.next();
  }

  emitNotificationBellRefresh() {
    this.refreshNotificationBellSource.next();
  }

  showStaticData() {
    const url = `${environment.apiUrl}/User/GetShowStaticData`;
    return this.httpClient.get(url);
  }
}
